import { AxiosResponse } from "axios";
import HttpService from "src/services/httpService";
import RouteService from "src/services/routeService";
import { ApiResponse } from "src/types";
import { downloadFromUrl } from "src/ui/utils/download";

import { unpackError } from "@dashboard/devices/api/helpers";

const getPresignedDownloadUrl = async (fileId: string) => {
    try {
        const endpoint = await RouteService.getStorageRoute();
        const response: AxiosResponse<{ model: string }> = await HttpService.get(`${endpoint}files/${fileId}/link`);
        return response.data.model;
    } catch (error) {
        throw unpackError(error);
    }
};

const invokeFileDownload = async (id: string | number, fileName: string, productFile?: boolean) => {
    try {
        const productEndpoint = await RouteService.getProductRoute();
        const storageEndpoint = await RouteService.getStorageRoute();
        const response: AxiosResponse<ApiResponse<string>> = await HttpService.get(
            `${productFile ? productEndpoint : storageEndpoint}files/${id}/link`,
        );

        downloadFromUrl(response.data.model, fileName);
    } catch (error) {
        throw unpackError(error);
    }
};

export type GetPresignedUrlPayload = { workspaceId: number; groupId: number | null; filename: string };
type GetPresignedUrlResponse = { uploadPresignedUrl: string; fileId: string };

async function getPresignedUrl(payload: GetPresignedUrlPayload) {
    const endpoint = await RouteService.getStorageRoute();
    return await HttpService.post<GetPresignedUrlPayload, AxiosResponse<ApiResponse<GetPresignedUrlResponse>>>(
        endpoint + "files",
        payload,
    );
}

export default {
    getPresignedDownloadUrl,
    getPresignedUrl,
    invokeFileDownload,
};
